export default __webpack_public_path__ + "static/media/firstlogo.6402c80c.webp";